module.exports = __webpack_public_path__ + "static/media/icon-info-white.c79a7f09.svg";